<template>
  <div class="p-4">
    <h2 class="text-xl font-bold mb-4">Icon Test</h2>
    <div class="space-y-2">
      <div class="flex items-center">
        <i class="fas fa-rocket mr-2"></i>
        <span>FAS Rocket Icon (Solid)</span>
      </div>
      <div class="flex items-center">
        <i class="far fa-rocket mr-2"></i>
        <span>FAR Rocket Icon (Regular)</span>
      </div>
      <div class="flex items-center">
        <i class="fas fa-book mr-2"></i>
        <span>FAS Book Icon (Solid)</span>
      </div>
      <div class="flex items-center">
        <i class="far fa-book mr-2"></i>
        <span>FAR Book Icon (Regular)</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
</script>